import { render, staticRenderFns } from "./DatesTabsItem.vue?vue&type=template&id=a621c4c4&scoped=true&"
import script from "./DatesTabsItem.vue?vue&type=script&lang=ts&"
export * from "./DatesTabsItem.vue?vue&type=script&lang=ts&"
import style0 from "./DatesTabsItem.vue?vue&type=style&index=0&id=a621c4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a621c4c4",
  null
  
)

export default component.exports